export const BI_REPORTS_MESSAGES = {
	MSG_BI_LOADING: 'Carregando dashboard do BI...',
	MSG_BI_LOAD_DASHBOARD: 'Carregar Dashboard',
	MSG_BI_LOAD_SUCCESS: 'Dashboard carregado com sucesso',

	MSG_BI_ERROR_TITLE: 'Erro ao carregar dashboard',
	MSG_BI_RETRY: 'Tentar novamente',
	MSG_BI_LOAD_ERROR: 'Erro ao carregar relatório BI',
	MSG_BI_AUTH_ERROR: 'Falha na autenticação do BI',
	MSG_BI_SCRIPT_LOAD_ERROR: 'Erro ao carregar script do BI',

	MSG_BI_TOKEN_NOT_CONFIGURED: 'Token do relatório não configurado',
	MSG_BI_TOKEN_NOT_FOUND: 'Token BI não encontrado nas permissões do usuário',
	MSG_BI_SALES_TOKEN_NOT_CONFIGURED:
		'Token do dashboard de vendas não configurado',
	MSG_BI_DEMAND_TOKEN_NOT_CONFIGURED:
		'Token do dashboard de demandas não configurado',
	MSG_BI_TOKEN_CONFIG_INSTRUCTION:
		'Configure o token do relatório para visualizar o dashboard.',

	MSG_BI_CONTAINER_NOT_FOUND: 'Container não encontrado',
	MSG_BI_CONTAINER_ERROR: 'Container para BI não encontrado',

	MSG_BI_USER_INFO_NOT_FOUND: 'Informações do usuário não encontradas',

	MSG_BI_MANUAL_LOAD_INSTRUCTION:
		'Clique no botão abaixo para carregar o dashboard',
} as const;

export const BI_REPORTS_CONFIG = {
	DEFAULT_CONTAINER_HEIGHT: '600px',
	DEFAULT_MIN_HEIGHT: '400px',

	SCRIPT_PATH: '/index.js',
	SCRIPT_LOAD_TIMEOUT: 10000, // 10 seconds

	CONTAINER_ID_PREFIX: 'bi-report-',
	CONTAINER_SELECTOR_PREFIX: '#bi-report-',

	TRANSITION_DURATION: '0.3s',
	TRANSITION_EASING: 'ease-in-out',

	MAX_RETRY_ATTEMPTS: 3,
	RETRY_DELAY: 2000,
} as const;

export const BI_REPORTS_STYLES = {
	ERROR_CONTAINER_STYLES: {
		padding: '20px',
		textAlign: 'center' as const,
		color: 'red.500',
	},

	SPINNER_CONFIG: {
		size: 'lg' as const,
		color: 'blue.500',
		thickness: '4px',
	},

	CONTAINER_STYLES: {
		border: '1px solid',
		borderColor: 'gray.200',
		borderRadius: 'md',
		overflow: 'hidden' as const,
		bg: 'white',
		boxShadow: 'sm',
	},
} as const;

export const BI_ENV_KEYS = {
	DOMAIN: 'REACT_APP_BI_DOMINIO',
	SALES_TOKEN: 'REACT_APP_BI_TOKEN_SALES_DASHBOARD',
	DEMAND_TOKEN: 'REACT_APP_BI_TOKEN_DEMAND_DASHBOARD',
	PAGE_TO_SHOW: 'REACT_APP_BI_PAGE_TO_SHOW',
	USER_TOKEN: 'REACT_APP_BI_USER_TOKEN',
} as const;
